import { Pipe, PipeTransform } from '@angular/core';

import { SortingOrder, TableSortDetails } from '../../shared/models/table-sort.model';
import { TableHeaderNamesConstants } from '../constants/table-header-names.constants';

@Pipe({
    name: 'indicateSort',
    standalone: false
})
export class IndicateSortPipe implements PipeTransform {


  transform(sortTableDetails: TableSortDetails, columnName: TableHeaderNamesConstants, sortSequence: SortingOrder): boolean {
    return sortTableDetails?.orderBy === sortSequence && columnName === sortTableDetails?.key;
  }

}
